export default __webpack_public_path__ + "assets/images/acfa0310f9107c918991c428c27b61d4.png";